import { useParams } from "react-router-dom";
import posthog from "posthog-js";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { Paragraph } from "components/atoms/Typography";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { useReportPlan } from "mutations/CustomPlans/useReportPlan";
import { useUnreportPlan } from "mutations/CustomPlans/useUnreportPlan";

import styles from "./EditCustomPlanButton.module.scss";

interface PublishPlanButtonProps {
    buildingModelCarbonReductionPlan: BuildingModelCarbonReductionPlan;
}

function ReportPlanButton({ buildingModelCarbonReductionPlan }: PublishPlanButtonProps) {
    const { mutate: reportPlanMutation, isLoading: reportPlanLoading } = useReportPlan();
    const { mutate: unreportPlanMutation, isLoading: unreportPlanLoading } = useUnreportPlan();
    const { planView } = useParams();

    const buildingModelUid = useBuildingModelUid();
    const loading = reportPlanLoading || unreportPlanLoading;
    const buttonEnabled = useFeatureFlagEnabled("ryanize-plan");

    if (buildingModelCarbonReductionPlan.planType !== "custom" || planView !== "custom") {
        return null;
    }

    const handleButtonClick = () => {
        posthog.capture("Report custom plan click.");
        if (buildingModelCarbonReductionPlan.isReported) {
            unreportPlanMutation({
                planId: buildingModelCarbonReductionPlan.id,
                buildingModelUid,
            });
            posthog.capture("Custom plan un-reported.");
        } else {
            reportPlanMutation({
                planId: buildingModelCarbonReductionPlan.id,
                buildingModelUid,
            });
            posthog.capture("Custom plan reported.");
        }
    };

    if (!buttonEnabled) {
        return null;
    }

    if (loading) {
        return (
            <button type="button" disabled={true} onClick={handleButtonClick} className={styles.addProjectButton}>
                <Paragraph style={{ color: "var(--audette-gray-400)" }}>
                    {unreportPlanLoading ? "Restoring..." : "Overriding..."}
                </Paragraph>
            </button>
        );
    }

    return (
        <button type="button" disabled={loading} onClick={handleButtonClick} className={styles.addProjectButton}>
            <Paragraph>
                {buildingModelCarbonReductionPlan.isReported ? "Restore recommendation" : "Override recommendation"}
            </Paragraph>
        </button>
    );
}

export default ReportPlanButton;
